module.exports = __webpack_public_path__ + "static/img/litho_press.dfadee5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/tools/litho_press.png
// module id = 454
// module chunks = 1